module.exports = __webpack_public_path__ + "media/images/flags/bq-69700956dfc5dd9519246c7720fb2b49.svg";